// extracted by mini-css-extract-plugin
module.exports = {"pin":"RoutineMachine_pin__3ItyC"};